var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"denied-page"},[_c('div',{staticClass:"denied-code"},[_vm._v("403")]),_c('h2',[_vm._v("当前账号无权访问此页面")]),_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/dashboard')}}},[_vm._v("返回工作台")])])
}
var staticRenderFns = []

export { render, staticRenderFns }